import { styleHelper } from "../../StyleHelpers";
import { Text } from "react-native";
import { FONT_FAMILY_DEFAULT } from "../../utils/Typography";
import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { useNavigation } from "@react-navigation/native";
import { routeNewCuration } from "../../Routes";
import { globalAny } from "../../utils/Utils";
import useToggleStore from "../../store/useToggle.store";
import useGenericContentStore from "../../store/genericContent.store";
import { Props } from "./model";
import { FeatureLineTwoFooter, FeatureTextFooter, StyledButton, StyledFooterContainer, StyledFooterMain, TextContainerFooter } from "./styled";

const FooterBanner = (props: Props) => {
	const navigation = useNavigation();
	const isToggleBehindTheScene = useToggleStore((state: any) => state.isToggleBehindTheScene);
	const { isNarrow } = useGenericContentStore((state: any) => ({
		isNarrow: state.isNarrow,
	}));
	const stylesLayout = isNarrow ? styleHelper.narrow.banner : styleHelper.wide.banner;

	/**
	 * Navigates to the Studio Access (New Curation) screen.
	 */
	const goToStudioAccessHandler = () => {
		//@ts-ignore
		navigation.navigate(routeNewCuration);
	};

	if (isToggleBehindTheScene) return null;

	return (
		<StyledFooterMain isNarrow={isNarrow}>
			{/* @ts-ignore */}
			<StyledFooterContainer height={stylesLayout?.height} width={stylesLayout?.width} banner={props.banner} isNarrow={isNarrow}>
				<FeatureTextFooter height={stylesLayout?.height}>
					{/* @ts-ignore */}
					<TextContainerFooter>
						<FeatureLineTwoFooter fontSize={stylesLayout?.lineTwo.fontSize} lineHeight={stylesLayout?.lineTwo.lineHeight}>
							{globalAny.language.banner_text}
						</FeatureLineTwoFooter>
					</TextContainerFooter>
					{/* @ts-ignore */}
					<StyledButton>
						<TouchableButton
							addMarginRight={true}
							componentTheme={ComponentThemeType.VinFast}
							type={ComponentTypeEnum.Primary}
							onPress={goToStudioAccessHandler}
						>
							<Text style={{ color: "white", fontFamily: FONT_FAMILY_DEFAULT, fontSize: 25 }}>
								{globalAny.language.go_behind_the_scenes}
							</Text>
						</TouchableButton>
					</StyledButton>
				</FeatureTextFooter>
			</StyledFooterContainer>
		</StyledFooterMain>
	);
};

export default FooterBanner;
